import { FC, useState } from 'react';

import { CorePublicEventProperties } from '@shared/types/event';
import { PublicUserConnectionComparison } from '@shared/types/userConnection';

import Button from '@components/buttons/Button';
import { EventImage } from '@components/cards/EventCard';
import { MultipleChoiceList } from '@components/form/MultipleChoiceList';
import { Popup } from '@components/layout/Popup/Popup';
import { TitleToolbar } from '@components/layout/TitleToolbar/TitleToolbar';

const labelToValue = (label: string) => {
  return label.toLowerCase().replace("'", '').replace(' ', '-');
};

const RSVP_OPTIONS = [
  { label: "I'm going", rsvpValue: 'yes' },
  { label: 'I wanna go', rsvpValue: 'maybe' },
  { label: 'I could be convinced', rsvpValue: 'maybe' },
  { label: "I can't go", rsvpValue: 'no' },
].map(({ label, rsvpValue }) => ({ label, value: labelToValue(label), rsvpValue }));

interface EventInvitationPopupContentProps {
  event: CorePublicEventProperties;
  connectionComparison: PublicUserConnectionComparison;
  onClose: () => void;
  onSubmit?: (selectedValue: string) => void;
}

interface EventInvitationPopupProps extends EventInvitationPopupContentProps {
  isVisible: boolean;
}

const PopupContent: FC<EventInvitationPopupContentProps> = ({
  event,
  connectionComparison,
  onSubmit,
}) => {
  const [selectedValue, setSelectedValue] = useState<string | undefined>();

  const handleSubmit = () => {
    if (!selectedValue) return;
    onSubmit?.(selectedValue);
  };

  return (
    <div>
      <TitleToolbar text="New Invite!" size="md" />
      <EventImage event={event} />
      <p className="mt-0">
        {connectionComparison.connectionName} is going to {event.title} and wants you to come!
      </p>
      <MultipleChoiceList options={RSVP_OPTIONS} onChange={([value]) => setSelectedValue(value)} />
      <Button className="mt-2" roundness="rounded" disabled={!selectedValue} onClick={handleSubmit}>
        Share update
      </Button>
    </div>
  );
};

export const EventInvitationPopup: FC<EventInvitationPopupProps> = ({ isVisible, ...props }) => {
  return (
    <Popup isVisible={isVisible} onClose={props.onClose} height="full">
      <Popup.Content>{isVisible && <PopupContent {...props} />}</Popup.Content>
    </Popup>
  );
};
